<div class="tab-section">
  <!-- TOOLBAR -->
  <div class="tab-toolbar">
    <span class="tab-count"
      >{{ drawerContratosTotalRec }} efetivo(s) no histórico do posto</span
    >
    <div class="tab-toolbar-actions">
     <!-- <button
        class="btn-ef-filter"
        [class.active]="showFiltro || filtroTurno !== null"
        (click)="showFiltro = !showFiltro"
        pTooltip="Filtrar"
        tooltipPosition="left"
      >
        <i class="ri-filter-3-line"></i>
        <span
          *ngIf="filtroTurno !== null"
          class="btn-ef-filter-dot"
        ></span>
      </button> -->
      <button class="btn-atribuir" (click)="openAtribuirDrawer()">
        <i class="fas fa-user-plus"></i>
        <span>Atribuir Efetivo</span>
      </button>
    </div> 
  </div>

  <!-- FILTROS INLINE -->
  <!--<div class="ef-filter-panel" *ngIf="showFiltro">
    <div class="ef-filter-group">
      <label class="ef-filter-label">Turno</label>
      <div class="ef-turno-list">
        <button
          class="ef-turno-opt"
          [class.active]="filtroTurno === null"
          (click)="filtroTurno = null"
        >
          <i class="ri-apps-line"></i> Todos
        </button>
        <button
          class="ef-turno-opt"
          *ngFor="let t of turnos"
          [class.active]="filtroTurno === t.id"
          (click)="filtroTurno = t.id ?? null"
        >
          <i
            [class]="getTurnoIconFromTurno(t)"
            [style.color]="getTurnoColorFromTurno(t)"
          ></i>
          {{ t.designacao }}
          <span class="ef-turno-opt-hrs"
            >{{ t.horaInicio?.slice(0, 5) }}–{{ t.horaFim?.slice(0, 5) }}</span
          >
        </button>
      </div>
    </div>
    <div class="ef-filter-footer">
      <button class="btn-ef-clear" (click)="clearFiltros()">
        <i class="fas fa-times"></i> Limpar
      </button>
      <button class="btn-ef-apply" (click)="applyFiltros(); showFiltro = false">
        <i class="fas fa-check"></i> Aplicar
      </button>
    </div>
  </div> -->

  <!-- SKELETON -->
  <div class="pgd-loading" *ngIf="loading">
    <p-skeleton height="48px" *ngFor="let i of [1, 2, 3, 4]"></p-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <!-- TABELA -->
    <div class="ef-table-wrap" *ngIf="contratos.length > 0; else emptyEfetivos">
      <table class="ef-table">
        <thead>
          <tr>
            <th>Efetivo</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of contratos; trackBy: trackById">
            <td>
              <div class="ef-cell-name">{{ c.nomeEfetivo || "—" }}</div>
              <div class="ef-cell-sub" *ngIf="c.idEfetivo">
                G-{{ ("000" + c.idEfetivo).slice(-4) }}
              </div>
            </td>
            <td class="ef-td-date">{{ formatDate(c.dataInicio) }}</td>
            <td class="ef-td-date">
              {{ c.dataFim ? formatDate(c.dataFim) : "—" }}
            </td>
            <td>
              <span class="badge-estado" [ngClass]="getEstadoContrato(c).css">
                {{ getEstadoContrato(c).label }}
              </span>
            </td>
            <td class="ef-td-actions">
              <p-menu
                #menuC
                [model]="menuContratosMap.get(c.id) ?? []"
                [popup]="true"
                appendTo="body"
                styleClass="sp-row-menu"
              ></p-menu>
              <button
                class="btn-row-menu"
                (click)="menuC.toggle($event); $event.stopPropagation()"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- PAGINAÇÃO -->
    <div class="ef-pag-wrap" *ngIf="drawerContratosTotalRec > 0">
      <app-paginator-control
        [first]="(page - 1) * pageSize"
        [rows]="pageSize"
        [totalRecords]="drawerContratosTotalRec"
        [rowsPerPageOptions]="[5, 10, 20]"
        [showCurrentPageReport]="true"
        (pageChange)="onPageChange($event)"
      />
    </div>

    <!-- EMPTY -->
    <ng-template #emptyEfetivos>
      <div class="pgd-empty-creative">
        <div class="pgd-empty-orbit">
          <div class="pgd-empty-orbit-ring"></div>
          <div class="pgd-empty-orbit-inner"><i class="ri-group-line"></i></div>
          <span class="pgd-orbit-dot pgd-orbit-dot--top"></span>
          <span class="pgd-orbit-dot pgd-orbit-dot--bottom"></span>
          <span class="pgd-orbit-dot pgd-orbit-dot--left"></span>
          <span class="pgd-orbit-dot pgd-orbit-dot--right"></span>
        </div>
        <p class="pgd-empty-title">Nenhum efetivo alocado</p>
        <p class="pgd-empty-sub">
          {{
            filtroTurno !== null
              ? "Sem resultados para os filtros aplicados."
              : "Atribui efetivos a este posto para gerir escalas e presenças."
          }}
        </p>
      </div>
    </ng-template>
  </ng-container>
</div>

<!-- DRAWER ATRIBUIR EFETIVO -->
<p-drawer
  [(visible)]="showAtribuirDrawer"
  position="right"
  [style]="{ width: 'min(900px, 96vw)' }"
  styleClass="ad-drawer-wrapper efetivo-drawer-dark"
  [modal]="true"
  [closable]="false"
  appendTo="body"
  (onHide)="fecharAtribuirDrawer()"
>
  <div class="ad-header">
    <div class="ad-header-left">
      <div class="ad-header-icon"><i class="fas fa-user-plus"></i></div>
      <div class="ad-header-titles">
        <div class="ad-title">Atribuir Efetivo</div>
        <div class="ad-subtitle">
          <i class="ri-building-4-line"></i>
          {{ posto?.nome || "Posto" }}
        </div>
      </div>
      <span class="ad-header-badge" *ngIf="atribuirSelecionados.length > 0">
        <i class="ri-checkbox-multiple-line"></i>
        {{ atribuirSelecionados.length }}
        {{ atribuirSelecionados.length > 1 ? "selecionados" : "selecionado" }}
      </span>
    </div>
    <div class="ad-header-right">
      <div class="ad-mode-toggle">
        <button
          type="button"
          class="ad-mode-btn"
          [class.active]="atribuirMode === 'single'"
          (click)="setAtribuirMode('single')"
        >
          <i class="fas fa-user"></i><span>Um</span>
        </button>
        <button
          type="button"
          class="ad-mode-btn"
          [class.active]="atribuirMode === 'multiple'"
          (click)="setAtribuirMode('multiple')"
        >
          <i class="ri-group-line"></i><span>Vários</span>
        </button>
      </div>
      <button
        type="button"
        class="ad-close-btn"
        (click)="fecharAtribuirDrawer()"
        aria-label="Fechar"
        pTooltip="Fechar"
        tooltipPosition="bottom"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <div [formGroup]="atribuirForm" class="ad-drawer-body">
    <div class="ad-panel-list">
      <div class="ad-search-bar">
        <i class="fas fa-search"></i>
        <input
          type="search"
          [value]="atribuirSearch"
          (input)="
            atribuirSearch = $any($event.target).value; onAtribuirSearch()
          "
          placeholder="Pesquisar por nome ou código..."
          aria-label="Pesquisar efetivos"
        />
      </div>

      <div class="ad-filter-grid">
        <p-select
          [(ngModel)]="atribuirFuncaoId"
          [ngModelOptions]="{ standalone: true }"
          [options]="atribuirFuncoes"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas as funções"
          [showClear]="true"
          appendTo="body"
          (onChange)="onAtribuirFilterChange()"
          styleClass="ad-filter-select"
          ariaLabel="Filtrar por função"
        />
        <p-select
          [(ngModel)]="atribuirCategoriaId"
          [ngModelOptions]="{ standalone: true }"
          [options]="atribuirCategorias"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas as categorias"
          [showClear]="true"
          appendTo="body"
          (onChange)="onAtribuirFilterChange()"
          styleClass="ad-filter-select"
          ariaLabel="Filtrar por categoria"
        />
      </div>

      <div class="ad-list-summary">
        <span>
          <strong>{{ atribuirTotal }}</strong>
          {{ atribuirTotal === 1 ? "efetivo disponível" : "efetivos disponíveis" }}
        </span>
        <button
          *ngIf="hasAtribuirFilters"
          type="button"
          class="ad-clear-filters"
          (click)="clearAtribuirFilters()"
        >
          <i class="ri-filter-off-line"></i>
          Limpar filtros
        </button>
      </div>

      <div
        class="ad-bulk-toolbar"
        *ngIf="
          atribuirMode === 'multiple' &&
          atribuirEfetivos.length > 0 &&
          !atribuirEfetivosLoading
        "
      >
        <span>
          <i class="ri-checkbox-multiple-line"></i>
          {{ currentPageSelectedCount }} de {{ atribuirEfetivos.length }} nesta página
        </span>
        <button type="button" (click)="toggleCurrentPageSelection()">
          <i
            [class]="
              isCurrentPageFullySelected
                ? 'ri-checkbox-blank-line'
                : 'ri-checkbox-multiple-line'
            "
          ></i>
          {{
            isCurrentPageFullySelected
              ? "Desmarcar página"
              : "Selecionar página"
          }}
        </button>
      </div>
      <div class="ad-ef-list-wrap">
        <ng-container *ngIf="atribuirEfetivosLoading; else listaEfetivos">
          <div class="ad-ef-skeleton">
            <p-skeleton
              height="56px"
              *ngFor="let i of [1, 2, 3, 4, 5]"
              borderRadius="10px"
            ></p-skeleton>
          </div>
        </ng-container>

        <ng-template #listaEfetivos>
          <div
            class="ad-ef-list"
            *ngIf="atribuirEfetivos.length > 0; else semEfetivos"
          >
            <button
              type="button"
              class="ad-ef-item"
              *ngFor="let ef of atribuirEfetivos; trackBy: trackById"
              [class.selected]="isSelected(ef)"
              [class.already]="isJaAlocado(ef)"
              [disabled]="isJaAlocado(ef)"
              [attr.aria-pressed]="isSelected(ef)"
              (click)="toggleSelecionado(ef)"
            >
              <div class="ad-ef-avatar">
                <img
                  *ngIf="ef.urlFotografia"
                  [src]="ef.urlFotografia"
                  [alt]="ef.nome"
                  class="ef-foto"
                  (error)="onImgError($event)"
                />
                <span class="ef-initials" *ngIf="!ef.urlFotografia">{{
                  getInitials(ef.nome)
                }}</span>
              </div>

              <div class="ad-ef-info">
                <div class="ad-ef-nome">{{ ef.nome }}</div>
                <div class="ad-ef-meta">
                  <span class="ad-ef-role">
                    <i class="ri-briefcase-4-line"></i>
                    {{ ef.nomeFuncao || "Sem função" }}
                  </span>
                  <span class="ad-ef-category" *ngIf="ef.nomeCategoria">
                    {{ ef.nomeCategoria }}
                  </span>
                </div>
                <div class="ad-ef-details">
                  <span
                    class="ad-ef-status"
                    [ngClass]="getEfetivoEstadoClass(ef)"
                  >
                    <i [class]="getEfetivoEstadoIcon(ef)"></i>
                    {{ getEfetivoEstado(ef) }}
                  </span>
                  <span class="ad-ef-phone" *ngIf="ef.numTelefone">
                    <i class="ri-phone-line"></i>{{ ef.numTelefone }}
                  </span>
                  <span class="ad-ef-code">G-{{ ("000" + ef.id).slice(-4) }}</span>
                </div>
              </div>

              <div class="ad-ef-right">
                <span class="ad-ef-ja-alocado" *ngIf="isJaAlocado(ef)">
                  <i class="ri-check-double-line"></i> No posto
                </span>
                <div class="ad-ef-toggle" *ngIf="!isJaAlocado(ef)">
                  <i class="ri-checkbox-circle-fill" *ngIf="isSelected(ef)"></i>
                  <i class="ri-add-circle-line" *ngIf="!isSelected(ef)"></i>
                </div>
              </div>
            </button>
          </div>

          <ng-template #semEfetivos>
            <div class="ad-ef-empty">
              <span class="ad-ef-empty-icon"><i class="ri-user-search-line"></i></span>
              <p>Nenhum efetivo encontrado</p>
              <small *ngIf="hasAtribuirFilters">
                Ajuste a pesquisa ou limpe os filtros para ver mais resultados.
              </small>
              <button
                *ngIf="hasAtribuirFilters"
                type="button"
                class="ad-empty-clear"
                (click)="clearAtribuirFilters()"
              >
                Limpar filtros
              </button>
            </div>
          </ng-template>
        </ng-template>
      </div>

      <div
        class="ad-ef-pag-wrap"
        *ngIf="atribuirTotal > 0 && !atribuirEfetivosLoading"
      >
        <app-paginator-control
          [first]="(atribuirPage - 1) * atribuirPageSize"
          [rows]="atribuirPageSize"
          [totalRecords]="atribuirTotal"
          [rowsPerPageOptions]="[10, 20, 50]"
          [showCurrentPageReport]="true"
          (pageChange)="onAtribuirPageChange($event)"
        />
      </div>
    </div>

    <div class="ad-panel-form">
      <div class="ad-empty-state" *ngIf="atribuirSelecionados.length === 0">
        <div class="ad-empty-graphic">
          <div class="ad-empty-ring-outer"></div>
          <div class="ad-empty-ring-mid"></div>
          <div class="ad-empty-icon-wrap">
            <i class="ri-user-search-line"></i>
          </div>
          <div class="ad-dot ad-dot--t"></div>
          <div class="ad-dot ad-dot--b"></div>
          <div class="ad-dot ad-dot--l"></div>
          <div class="ad-dot ad-dot--r"></div>
        </div>
        <div class="ad-empty-title">Nenhum efetivo selecionado</div>
        <div class="ad-empty-body">
          Seleciona um ou mais efetivos na lista ao lado<br />
          para configurar a alocação.
        </div>
        <div class="ad-empty-hint">
          <i class="fas fa-arrow-left"></i>
          Clica num efetivo para começar
        </div>
      </div>

      <ng-container *ngIf="atribuirSelecionados.length > 0">
        <div class="ad-selected-section">
          <div class="ad-selected-header">
            <div class="ad-selected-title">
              <i class="ri-checkbox-multiple-line"></i>
              <span>Selecionados ({{ atribuirSelecionados.length }})</span>
            </div>
            <button
              *ngIf="atribuirMode === 'multiple'"
              type="button"
              class="ad-selected-clear"
              (click)="clearAtribuirSelection()"
            >
              <i class="ri-delete-bin-6-line"></i>
              Limpar todos
            </button>
          </div>

          <div class="ad-bulk-summary" *ngIf="atribuirMode === 'multiple'">
            <span class="ad-bulk-summary-icon">
              <i class="ri-group-line"></i>
            </span>
            <div>
              <strong>{{ atribuirSelecionados.length }} efetivos no lote</strong>
              <small>As datas e o documento serão aplicados a todos.</small>
            </div>
          </div>

          <div
            class="ad-selected-chips"
            [class.is-multiple]="atribuirMode === 'multiple'"
          >
            <div class="ad-chip" *ngFor="let ef of atribuirSelecionados">
              <div class="ad-chip-avatar">
                <img
                  *ngIf="ef.urlFotografia"
                  [src]="ef.urlFotografia"
                  [alt]="ef.nome"
                />
                <span *ngIf="!ef.urlFotografia">{{
                  getInitials(ef.nome)
                }}</span>
              </div>
              <div class="ad-chip-info">
                <span class="ad-chip-nome">{{ ef.nome }}</span>
                <span class="ad-chip-role">
                  {{ ef.nomeFuncao || "Sem função" }}
                  <ng-container *ngIf="ef.nomeCategoria">
                    · {{ ef.nomeCategoria }}
                  </ng-container>
                </span>
                <span class="ad-chip-details">
                  <span
                    class="ad-ef-status"
                    [ngClass]="getEfetivoEstadoClass(ef)"
                  >
                    <i [class]="getEfetivoEstadoIcon(ef)"></i>
                    {{ getEfetivoEstado(ef) }}
                  </span>
                  <span *ngIf="ef.numTelefone">
                    <i class="ri-phone-line"></i>{{ ef.numTelefone }}
                  </span>
                </span>
              </div>
              <button
                type="button"
                class="ad-chip-remove"
                (click)="removerSelecionado(ef)"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="ad-divider"></div>

        <div class="ad-bulk-config" *ngIf="atribuirMode === 'multiple'">
          <span class="ad-bulk-config-step">2</span>
          <div>
            <strong>Configuração comum</strong>
            <small>Defina abaixo as condições para todo o lote selecionado.</small>
          </div>
        </div>

        <div class="ad-form">
          <div class="ad-form-row">
            <div class="ad-form-group">
              <label class="ad-field-label">
                <i class="ri-calendar-line"></i>
                <span>Data de Início</span>
                <strong>*</strong>
              </label>

              <p-datepicker
                formControlName="dataInicio"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                appendTo="body"
                styleClass="ad-datepicker"
                [autoZIndex]="true"
                [baseZIndex]="1000010"
                panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
            </div>

            <div class="ad-form-group">
              <label class="ad-field-label">
                <i class="fas fa-calendar-check"></i>
                <span>Data de Fim</span>
                <small>Opcional</small>
              </label>

              <p-datepicker
                formControlName="dataFim"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                appendTo="body"
                styleClass="ad-datepicker"
                [showClear]="true"
                [autoZIndex]="true"
                [baseZIndex]="1000010"
                panelStyleClass="drawer-datepicker-panel"
              >
              </p-datepicker>
            </div>
          </div>

          <div class="ad-form-group">
            <label class="ad-field-label">
              <i class="ri-attachment-2"></i>
              <span>Documento</span>
              <small>Opcional</small>
            </label>

            <label
              class="ad-file-label"
              [class.ad-file-has]="atribuirDocumento"
            >
              <i class="ri-attachment-2"></i>
              <span>{{
                atribuirDocumento
                  ? atribuirDocumento.name
                  : "Anexar documento (PDF, imagem)"
              }}</span>
              <input
                type="file"
                class="ad-file-input"
                accept=".pdf,.jpg,.jpeg,.png"
                (change)="onFileChange($event)"
              />
              <button
                *ngIf="atribuirDocumento"
                class="ad-file-clear"
                (click)="atribuirDocumento = null; $event.preventDefault()"
              >
                <i class="fas fa-times"></i>
              </button>
            </label>
          </div>

          <div class="ad-info-note">
            <i class="fas fa-shield-alt"></i>
            <span
              >A atribuição ficará registada no historial do efetivo e do
              posto.</span
            >
          </div>
        </div>

        <div class="ad-form-actions">
          <button
            type="button"
            class="ad-btn-cancel"
            (click)="fecharAtribuirDrawer()"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="ad-btn-confirm"
            [disabled]="
              atribuirForm.invalid ||
              atribuirSelecionados.length === 0 ||
              atribuirSubmitting
            "
            (click)="confirmarAtribuicao()"
          >
            <i class="ri-loader-4-line ad-spin" *ngIf="atribuirSubmitting"></i>
            <i class="fas fa-user-plus" *ngIf="!atribuirSubmitting"></i>
            <span>{{
              atribuirSubmitting
                ? "A processar..."
                : atribuirMode === "multiple"
                  ? "Confirmar atribuições"
                  : "Confirmar atribuição"
            }}</span>
            <span
              class="ad-btn-badge"
              *ngIf="!atribuirSubmitting && atribuirSelecionados.length > 0"
            >
              {{ atribuirSelecionados.length }}
            </span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</p-drawer>

<!-- DRAWER: DESATRIBUIR / REMOVER -->
<p-drawer
  [(visible)]="showDesatribuirDialog"
  position="right"
  [modal]="true"
  [closable]="false"
  appendTo="body"
  styleClass="dr-remocao-wrapper efetivo-drawer-dark"
  [style]="{ width: 'min(480px, 96vw)' }"
  (onHide)="fecharDesatribuirDialog()"
>
  <div class="dr-root" *ngIf="desatribuirForm" [formGroup]="desatribuirForm">
    <div class="dr-header">
      <div class="dr-header-icon dr-icon--danger">
        <i class="ri-user-unfollow-line"></i>
      </div>
      <div class="dr-header-info">
        <div class="dr-title">Remover do Posto</div>
        <div class="dr-subtitle">
          {{ desatribuirContrato?.nomeEfetivo ?? "—" }}
        </div>
      </div>
      <button
        type="button"
        class="ad-close-btn"
        (click)="fecharDesatribuirDialog()"
        aria-label="Fechar"
        pTooltip="Fechar"
        tooltipPosition="bottom"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="dr-body">
      <div class="dr-contrato-info">
        <div class="dr-contrato-row">
          <i class="fas fa-clock"></i>
          <span
            >Turno:
            <strong>{{
              desatribuirContrato?.turno?.designacao ??
                desatribuirContrato?.turno ??
                "—"
            }}</strong></span
          >
        </div>
        <div class="dr-contrato-row">
          <i class="ri-calendar-line"></i>
          <span
            >Desde:
            <strong>{{
              formatDate(desatribuirContrato?.dataInicio)
            }}</strong></span
          >
        </div>
      </div>

      <!-- SELEÇÃO DE MOTIVO -->
      <div class="dr-form-group">
        <label class="dr-label"
          >Motivo de Remoção <span class="ad-required">*</span></label
        >
        <div class="dr-motivo-options">
          <button
            type="button"
            class="dr-motivo-btn"
            *ngFor="let m of motivosRemocao"
            [class.active]="
              desatribuirForm.get('motivoRemocao')?.value === m.value
            "
            (click)="desatribuirForm.get('motivoRemocao')?.setValue(m.value)"
          >
            <i [class]="m.icon"></i> {{ m.label }}
          </button>
        </div>
        <span
          class="ad-error-msg"
          *ngIf="
            desatribuirForm.get('motivoRemocao')?.invalid &&
            desatribuirForm.get('motivoRemocao')?.touched
          "
        >
          Seleciona um motivo
        </span>
      </div>

      <!-- MOTIVO OUTRO (CAMPO DINÂMICO) -->
      <div
        class="dr-form-group"
        *ngIf="desatribuirForm.get('motivoRemocao')?.value === 'OUTRO'"
      >
        <label class="dr-label"
          >Especifique o Motivo <span class="ad-required">*</span></label
        >
        <input
          type="text"
          class="dr-textarea"
          style="min-height: 40px; height: 40px;"
          formControlName="motivoOutro"
          placeholder="Descreva o motivo da remoção..."
        />
        <span
          class="ad-error-msg"
          *ngIf="
            desatribuirForm.get('motivoOutro')?.invalid &&
            desatribuirForm.get('motivoOutro')?.touched
          "
        >
          Indique o motivo de remoção.
        </span>
      </div>

      <!-- EFETIVO SUBTITUTO (COMBOBOX COM EFETIVOS ATIVOS) -->
      <div class="dr-form-group">
        <label class="dr-label">
          Efetivo Substituto
          <span class="ad-optional-badge">Opcional</span>
        </label>
        <p-select
          formControlName="idEfetivoSubstituto"
          [options]="efetivosActivos"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione um efetivo substituto..."
          [showClear]="true"
          [filter]="true"
          filterBy="label"
          [loading]="loadingEfetivosActivos"
          appendTo="body"
          styleClass="w-full ad-filter-select"
          ariaLabel="Selecionar efetivo substituto"
        />
      </div>

      <!-- CONFIRMAÇÃO DO SUPERVISOR -->
      <div
        class="dr-form-group"
        *ngIf="desatribuirForm.get('idEfetivoSubstituto')?.value"
      >
        <label class="dr-checkbox-label">
          <input type="checkbox" formControlName="confirmadoPorSupervisor" />
          <span class="confirmar-atribuicao">Atribuição confirmada pelo Supervisor</span>
        </label>
      </div>

      <div class="dr-form-group">
        <label class="dr-label"
          >Data de Remoção <span class="ad-required">*</span></label
        >
        <p-datepicker
          formControlName="dataRemocao"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          styleClass="w-full ad-datepicker"
          placeholder="dd/mm/aaaa"
          [autoZIndex]="true"
          [baseZIndex]="1000010"
          panelStyleClass="drawer-datepicker-panel"
        >
        </p-datepicker>
      </div>

      <div class="dr-form-group">
        <label class="dr-label"
          >Observações <span class="ad-optional-badge">Opcional</span></label
        >
        <textarea
          class="dr-textarea"
          formControlName="observacaoRemocao"
          rows="3"
          placeholder="Motivo adicional, contexto..."
        ></textarea>
      </div>

      <div class="dr-warn-note">
        <i class="ri-alert-line"></i>
        <span
          >Esta ação não elimina o efetivo do sistema. Apenas termina a alocação
          neste posto.</span
        >
      </div>
    </div>

    <!-- BOTÕES DE AÇÃO DO DRAWER -->
    <div class="dr-footer">
      <button
        type="button"
        class="ad-btn-cancel"
        (click)="fecharDesatribuirDialog()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="dr-btn-remove"
        [disabled]="desatribuirFormInvalid"
        (click)="confirmarDesatribuicao()"
      >
        <i class="ri-loader-4-line ad-spin" *ngIf="desatribuirSubmitting"></i>
        <i class="ri-user-unfollow-line" *ngIf="!desatribuirSubmitting"></i>
        {{ desatribuirSubmitting ? "A processar..." : "Confirmar Remoção" }}
      </button>
    </div>
  </div>
</p-drawer>
